// Header row for ProductionOrder
import { Row, Col } from "antd";
import SalesHistoryIcon from "../PointOfSale/Retail/SvgComponent/SalesHistoryIcon";
import POSLogo from "../../assets/images/NewLogoCW.svg";
import sideMenu from "../../assets/images/side-menu.svg";
import userIcon from "../../assets/images/userId.svg";
import Online from "../../assets/images/green.svg";
import Ofline from "../../assets/images/red.svg";
import LockIcon from "../../assets/images/lock-icon.svg";
import useAuthStore from "../../stores/useAuthStore";

const HeaderBar = ({
  setTillLink,
  posConfigData,
  handleCancel,
  history,
  posConfig,
  totalSalePrice,
  setShowOrderHistory,
  formattedDateTime,
  setIsLocked,
  userData,
}) => {
  if (!userData) return null;

  return (
    <Row style={{ padding: "0.5% 0", height: "9vh", alignItems: "center", fontSize: "1vw" }}>
      <Col onClick={() => setTillLink(true)} style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }} span={2}>
        <img src={sideMenu} style={{ paddingLeft: "0.5rem", height: "2vw" }} />
      </Col>
      <Col span={3}>
        <img
          src={POSLogo}
          onClick={() => { handleCancel(); history.push("/"); }}
          style={{ height: "2.5vw", paddingLeft: "0.4vw", cursor: "pointer" }}
        />
      </Col>
      <Col span={2} style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
        <span style={{ fontFamily: "Inter", fontWeight: 600, fontSize: "1.5em", color: "#0F0718", marginLeft: "5vw", borderRadius: "2px", marginTop: "0.45rem" }}>
          Production
        </span>
      </Col>
      <Col span={6} style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}></Col>
      <Col span={1} />
      {posConfig?.showProductionHistory === "Y" ? (
        <Col
          span={2}
          style={{ display: "flex", justifyContent: "center", alignItems: "center", paddingLeft: "5.2vw", cursor: totalSalePrice > 0 ? "not-allowed" : "pointer", opacity: totalSalePrice > 0 ? 0.5 : 1 }}
          onClick={() => { if (totalSalePrice <= 0) setShowOrderHistory(true); }}
        >
          <SalesHistoryIcon color={"#0F0718"} />
        </Col>
      ) : (
        <Col span={2} />
      )}
      <Col span={4} style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
        <span style={{ fontFamily: "Inter", fontWeight: 500, fontSize: "1em", color: "#929098", marginLeft: "1vw", marginRight: "1vw" }}>{formattedDateTime}</span>
      </Col>
      <Col span={4} style={{ display: "flex", justifyContent: "end", alignItems: "center" }}>
        <img onClick={() => setIsLocked(true)} src={LockIcon} style={{ height: "3vh", cursor: "pointer", marginRight: "0.7rem" }} />
        <div style={{ display: "flex", alignItems: "end", justifyContent: "center", padding: "0.5vw", border: "1px solid #3C424B", borderRadius: "50%" }}>
          <img src={userIcon} style={{ height: "2.7vh" }} />
        </div>
        <div style={{ marginLeft: "1vw", display: "flex", flexDirection: "column" }}>
          <span style={{ color: "#0F0718", fontSize: "1em", fontFamily: "Inter", fontWeight: "500", wordWrap: "break-word" }}>{userData.user}</span>
          <span style={{ color: "#0F0718", fontSize: "0.8em", fontFamily: "Inter", fontWeight: "500", wordWrap: "break-word" }}>
            Till ID : {useAuthStore.getState().tillValue?.name}
          </span>
        </div>
        <div style={{ marginLeft: "3%" }}>
          <img src={Online} style={{ display: !navigator.onLine && "none", height: "2.5vh", cursor: "pointer", paddingBottom: "0.5vh" }} /> &nbsp;
          <img src={Ofline} style={{ display: navigator.onLine && "none", height: "2.5vh", cursor: "pointer", paddingBottom: "0.5vh" }} /> &nbsp;
        </div>
      </Col>
    </Row>
  );
};

export default HeaderBar;
